
let global:Global={    
    QD:"",
    AW:"",
    QD_DESC:"",
    AW_DESC:"",
    baseNcImgUrl:"http://img.game.dwstatic.com/f2e/static/activity/yygame/wbtg/new/images"||"nc",    //nc奖品图片地址
    statpidOption:{
        eid:"",
        eid_desc:"",
        gam:"",
        gse:""
    },
    init() {
        this.getQDAW();
        var option = {
            pro: 'yygame',
            eid: `login/${this['QD']}/TGDS/${this['AW']}/NEW`,
            eid_desc: `登录/${this['QD_DESC']}/推广大使/${this['AW_DESC']}/新用户`,
            rso: document.location.href,
            rso_desc: '推广大使'
        }
        this.statpidOption={
            eid: `click/${this['QD']}/TGDS/${this['AW']}`,
            eid_desc: `点击/${this['QD_DESC']}/推广大使/${this['AW_DESC']}`,
            gam:"default",
            gse:"default"
        };
        // $.f2e.util.statpid.loginStat(option);
        f2eGame.port.statpid.loginStat(option);
    },
    getQDAW() {
        //获取渠道，属性
        let codeString = f2eGame.util.getParam("code");
        let QD = this['defaultQD'] = Object.keys(window._CONFIG['QD'])[0];
        let AW = this['defaultAW'] = Object.keys(window._CONFIG['AW'])[0];
        if (codeString && codeString.indexOf('IV') >= 0) {
            QD = codeString.split('IV')[0];
            AW = codeString.split('IV')[1];
        }
        this['QD'] = QD;
        this['AW'] = AW;
        this['QD_DESC'] = window._CONFIG['QD'][QD];
        this['AW_DESC'] = window._CONFIG['AW'][AW];
    },
    isLogin(callback){
        f2eGame.port.udb.isLogin()
       .then((res:any)=>{
           if (res){
               callback()
           }else{
               f2eGame.port.udb.login({
                   type:"YYQ"
               });
           }
       })
   }
}
export default global;



// WEBPACK FOOTER //
// ./src/utils/global.ts